export class ApiClientConfig {
  apiEndpoint!: string;
  apiKey!: string;
}
